import { Component, OnInit } from '@angular/core';
import {DialogRef} from "../../../../core/components/dialog/dialog-ref";
import {DocumentManagementStoreService} from "../../../services/document-management-store.service";
import {ElaborationDocument} from "../../../models/elaboration-doc";
import {ELABORATION_ASS_ACTIONS} from "../../../models/elaboration-ass-actions";
import {PraticaLight} from "../../../../common/models/pratica/pratica-light";
import {DocumentManagementService} from "../../../services/document-management.service";
import { ServicesSearch } from 'src/app/search/services/search.service';
import { SearchRequest } from 'src/app/common/models/dto/search-request';
import { TipoPratica } from 'src/app/common/models/tipologiche/tipo-pratica';
import { switchMap, take } from 'rxjs/operators';
import { CriterioCustom } from 'src/app/common/models/criterio-custom';
import { ElaborationDocumentFilter, ElaborationDocumentFilterEntity } from 'src/app/document-management/models/elaboration-doc-filter';
import { filterElaborationEntityClean } from 'src/app/pratica/components/wizard-creazione/utils/wizard-utils';
import { ElaborationEntityConstants } from 'src/app/pratica/components/wizard-creazione/constants/elaboration-entity-constants';
import { CriteriUtente } from 'src/app/common/models/criteri-utente';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';

@Component({
  selector: 'app-document-ass-modal',
  templateUrl: './document-ass-modal.component.html',
  styleUrls: ['./document-ass-modal.component.css']
})
export class DocumentAssModalComponent implements OnInit {

  elaboration: ElaborationDocument;
  searchText: string = '';
  /*numRuoloSuggested: string = '';
  annoRuoloSuggested: string = '';*/
  pratiche: PraticaLight[] = [];
  buttonAssociaHide : boolean = false;
  annoRuolo: string;
  numeroRuolo: string;


  actions = ELABORATION_ASS_ACTIONS;

  constructor(
    private documentManagementStoreService: DocumentManagementStoreService,
    private dialogRef: DialogRef,
    private documentManagementService: DocumentManagementService,
    private dialogConfig: DialogConfig,
    private searchService: ServicesSearch
  ) {
    if(this.dialogConfig.data && this.dialogConfig.data.source && this.dialogConfig.data.source === 'PDA'){
      this.getPraticheByAnnoRuolo();
      this.buttonAssociaHide = true;
    } else {
      this.getPraticheByIdElab();
    }


    /*TODO: Use store
    this.documentManagementStoreService.elaboration$.subscribe(elab => {
      this.documentManagementService.getElaborationEntities(elab.idElaborazione).subscribe(response => {
        this.preselezionaNumAnnoRuolo(response);
        this.searchBySuggeriti(this.numRuoloSuggested,this.annoRuoloSuggested)
      });
    });*/
  }


  ngOnInit() {

  }

  private getPraticheByAnnoRuolo(){
    if (this.dialogConfig.data) {
      this.annoRuolo = this.dialogConfig.data.annoRuolo;
      this.numeroRuolo = this.dialogConfig.data.numeroRuolo;
      if(this.annoRuolo && this.numeroRuolo){
        this.documentManagementService.getPraticheByAnnoRuolo(this.annoRuolo,this.numeroRuolo).subscribe(pratiche => {
          this.pratiche = pratiche;
        });
      }
    }
  }

  private getPraticheByIdElab() {
    this.documentManagementStoreService.elaboration$.pipe(
      switchMap(res =>
        this.documentManagementService.getElaborationPratiche(res.idElaborazione)),
      take(1),
    ).subscribe(pratiche => {
      this.pratiche = pratiche;
    });
  }

  /*private preselezionaNumAnnoRuolo(entities: ElaborationDocumentFilterEntity[]){
    if(entities && entities.length > 0){
      let numAndAnnoRuoloSuggested = filterElaborationEntityClean(entities, [ElaborationEntityConstants.CASE_NUMBER]);
      if(numAndAnnoRuoloSuggested &&
        numAndAnnoRuoloSuggested.length > 0){
          let str = numAndAnnoRuoloSuggested[0].valore;
          this.numRuoloSuggested = str.slice(0,str.indexOf("/"));
          let anno = str.slice(str.indexOf("/")+1);
          this.annoRuoloSuggested = anno.length == 4 ? anno : "20"+anno;
        }
    }
  }*/

  search() {
    if(this.searchText.length == 0) {
      this.getPraticheByIdElab();
      return;
    }
    let searchRequest: SearchRequest = new SearchRequest;
    searchRequest.searchCriteria.searchText = this.searchText;
    searchRequest.includePratiche = true;

    this.searchService.search(searchRequest).subscribe(response => {
      this.pratiche = response.pratiche;
    })
  }

  /*searchBySuggeriti(numeroRuolo: string, annoRuolo: string){

    if(numeroRuolo.length == 0){
      this.getPraticheByIdElab();
      return;
    }

    let searchRequest: SearchRequest = new SearchRequest;
    searchRequest.searchCriteria.criteriUtente = new CriteriUtente();
    searchRequest.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'] = new CriterioCustom();
    searchRequest.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].uid = "numeroRuolo";
    searchRequest.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].value = numeroRuolo;
    searchRequest.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].dataType = 'string';
    searchRequest.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].label = 'Numero Ruolo';
    searchRequest.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].labelGruppo = 'Ruolo';
    searchRequest.searchCriteria.criteriUtente.criteriCustom['annoRuolo'] = new CriterioCustom();
    searchRequest.searchCriteria.criteriUtente.criteriCustom['annoRuolo'].uid = "annoRuolo";
    searchRequest.searchCriteria.criteriUtente.criteriCustom['annoRuolo'].value = annoRuolo;
    searchRequest.searchCriteria.criteriUtente.criteriCustom['annoRuolo'].dataType = 'string';
    searchRequest.searchCriteria.criteriUtente.criteriCustom['annoRuolo'].label = 'Anno Ruolo';
    searchRequest.searchCriteria.criteriUtente.criteriCustom['annoRuolo'].labelGruppo = 'Ruolo';
    searchRequest.includePratiche = true;

    this.searchService.search(searchRequest).subscribe(response => {
      this.pratiche = response.pratiche;
    });

  }*/

  selectAction(action: ELABORATION_ASS_ACTIONS, idPratica: string = null, idFascicolo: string = null, tipoPratica: TipoPratica = null, codice?: string) {
    this.dialogRef.close({action, idPratica, idFascicolo, tipoPratica, codice});
  }

  createFascicolo(action: ELABORATION_ASS_ACTIONS, praticaValue: any){
    this.selectAction(action, praticaValue.id, null, praticaValue.tipoPratica, praticaValue.codice);
  }

  associaFascicolo(action: ELABORATION_ASS_ACTIONS, idFascicolo: string) {
    this.selectAction(action, null, idFascicolo, null);
  }

}
